import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userApi } from '~services/api/user';
import { getUserId } from '~store/auth/authSlice';

export const useUserTags = () => {
	const id = useSelector(getUserId);
	const {
		data: tags = [],
		isLoading: tagsLoading,
		isSuccess: tagsSuccess,
	} = userApi.useTagsQuery({ id }, { skip: !id });
	const {
		data: experiments = [],
		isLoading: experimentsLoading,
		isSuccess: experimentsSuccess,
	} = userApi.useExperimentsQuery({ id }, { skip: !id });

	const isLoading = useMemo(
		() => tagsLoading || experimentsLoading,
		[experimentsLoading, tagsLoading]
	);

	const isSuccess = useMemo(
		() => tagsSuccess && experimentsSuccess,
		[tagsSuccess, experimentsSuccess]
	);

	const userTags = useMemo(
		() => [...experiments, ...tags],
		[experiments, tags]
	);

	return { isLoading, userTags, id, isSuccess };
};
